import toast from "react-hot-toast";

import { ATTENDANCE_EXPORT_WARNING_LIMIT } from "../../../models/attendance";

export const EXPORT_QUEUED_TOAST_ID = "attendance-export-queued";
export const EXPORT_QUEUED_TOAST_DURATION_MS = 8_000;

const WARNING_LIMIT_LABEL = ATTENDANCE_EXPORT_WARNING_LIMIT.toLocaleString("es-AR");

/**
 * Aviso del export diferido (202): con más de ATTENDANCE_EXPORT_WARNING_LIMIT
 * registros el CSV se genera en segundo plano y llega como notificación en la
 * campana del header, desde donde se descarga.
 *
 * Tonos de SYSTEM_DESIGN.md §3.2 (info) y escala §3.3 (Body / Body Small).
 */
export const ExportQueuedToast = ({ toastId, visible }: { toastId: string; visible: boolean }) => (
  <div
    className={`export-queued-toast${visible ? "" : " export-queued-toast--leaving"}`}
    role="status"
    aria-live="polite"
  >
    <span className="export-queued-toast__icon" aria-hidden="true">
      <i className="pi pi-clock" />
    </span>
    <div className="export-queued-toast__body">
      <span className="export-queued-toast__title">Estamos generando tu CSV</span>
      <span className="export-queued-toast__text">
        Como son más de {WARNING_LIMIT_LABEL} registros, lo preparamos en segundo plano.
        Cuando esté listo te va a llegar una notificación para descargarlo.
      </span>
    </div>
    <button
      type="button"
      className="export-queued-toast__close"
      aria-label="Cerrar aviso"
      onClick={() => toast.dismiss(toastId)}
    >
      <i className="pi pi-times" aria-hidden="true" />
    </button>
  </div>
);

export const showExportQueuedToast = () =>
  toast.custom((t) => <ExportQueuedToast toastId={t.id} visible={t.visible} />, {
    id: EXPORT_QUEUED_TOAST_ID,
    duration: EXPORT_QUEUED_TOAST_DURATION_MS,
  });
